import React from "react";

const Drawer = ({ props }) => {
  const { isOpen, Component, closeFn, componentProps } = props;
  const width = componentProps.width ? componentProps.width : "90%";

  if (!isOpen) return null;
  return (
    <>
      <div
        key={componentProps.item?._id + "Drawer"}
        className={`fixed -top-4 left-0 inset-y-0 right-0  w-full h-[100%] cursor-not-allowed bg-black bg-opacity-50 z-40`}
        onClick={closeFn}
      ></div>

      <div
        className={`fixed -top-4 right-0 h-full bg-white z-50 overflow-y-auto  rounded-lg w-[${
          componentProps?.width ? width : "80%"
        }] md:w-[${width}] sm:w-[${width}] shadow-lg transform  transition-all duration-300
            ${isOpen ? "animate-slideInRight" : "animate-slideOutRight"} `}
      >
        <button
          className="absolute right-6 text-xl font-bold hover:font-bold hover:text-2xl "
          onClick={closeFn}
        >
          &times;
        </button>
        {Component && <Component props={{ ...componentProps }} />}
      </div>
    </>
  );
};

export default Drawer;
